import {
  CreateDownloadConfig,
  DownloadConfig,
  DownloadRequest,
  UpdateDownloadConfig,
} from '../../schemas/DownloadConfig.schema';
import { MaggieHttp } from '../MaggieHttp';

/**
 * Get all download configurations
 */
export async function fetchDownloadConfigurations(): Promise<DownloadConfig[]> {
  const { data } = await MaggieHttp.maggie.get<DownloadConfig[]>('/investigator/configurations');
  return data;
}

/**
 * Get a specific download configuration by table name
 */
export async function fetchDownloadConfigByTableName(tableName: string): Promise<DownloadConfig> {
  const { data } = await MaggieHttp.maggie.get<DownloadConfig>(
    `/investigator/configurations/${encodeURIComponent(tableName)}`
  );
  return data;
}

/**
 * Create a new download configuration
 */
export async function createDownloadConfiguration(config: CreateDownloadConfig): Promise<DownloadConfig> {
  const { data } = await MaggieHttp.maggie.post<CreateDownloadConfig, DownloadConfig>(
    '/investigator/configurations',
    config
  );
  return data;
}

/**
 * Update an existing download configuration
 */
export async function updateDownloadConfiguration(
  id: number,
  config: UpdateDownloadConfig
): Promise<DownloadConfig> {
  const { data } = await MaggieHttp.maggie.put<UpdateDownloadConfig, DownloadConfig>(
    `/investigator/configurations/${id}`,
    config
  );
  return data;
}

/**
 * Delete a download configuration
 */
export async function deleteDownloadConfiguration(id: number): Promise<void> {
  await MaggieHttp.maggie.delete(`/investigator/configurations/${id}`);
}

/**
 * Download table data with filters
 * Returns a Blob that can be used to trigger a file download
 */
export async function downloadTableData(request: DownloadRequest): Promise<Blob> {
  const { data } = await MaggieHttp.maggie.post<DownloadRequest, Blob>('/investigator/download', request, {
    responseType: 'blob',
  });
  return data;
}

/**
 * Helper function to trigger browser download from a Blob
 */
export function triggerFileDownload(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
